import { BIBLE_BOOKS } from "../mocks/bibleBooks";

export interface ReadingPlanDay {
  day: number;
  chapters: { bookId: number; bookName: string; chapter: number }[];
}

// Chronological Bible reading order by book ID
const CHRONOLOGICAL_BOOK_ORDER: number[] = [
  1, 18, 2, 3, 4, 5,
  6, 7, 8,
  9, 10, 19, 11, 20, 21, 22,
  12, 13, 14,
  28, 30, 32, 33, 23,
  24, 25, 26, 27, 31, 34, 35, 36,
  15, 37, 38, 17, 16, 29, 39,
  40, 41, 42, 43, 44,
  59, 48, 52, 53, 46, 47, 45,
  49, 50, 51, 57,
  54, 55, 56,
  58, 60, 61, 62, 63, 64, 65, 66,
];

function generateAnnualPlan(): ReadingPlanDay[] {
  const allChapters: { bookId: number; bookName: string; chapter: number }[] = [];

  for (const bookId of CHRONOLOGICAL_BOOK_ORDER) {
    const book = BIBLE_BOOKS.find((b) => b.id === bookId);
    if (!book) continue;
    for (let c = 1; c <= book.chapters; c++) {
      allChapters.push({ bookId: book.id, bookName: book.name, chapter: c });
    }
  }

  // 1189 total chapters over 365 days
  // 94 days with 4 chapters, 271 days with 3 chapters
  const plan: ReadingPlanDay[] = [];
  let idx = 0;
  const TOTAL_DAYS = 365;
  const TOTAL_FOUR_CHAPTER_DAYS = 94;

  for (let day = 1; day <= TOTAL_DAYS; day++) {
    const target4 = Math.floor((day * TOTAL_FOUR_CHAPTER_DAYS) / TOTAL_DAYS);
    const prev4 = Math.floor(((day - 1) * TOTAL_FOUR_CHAPTER_DAYS) / TOTAL_DAYS);
    const chaptersToday = target4 > prev4 ? 4 : 3;
    plan.push({
      day,
      chapters: allChapters.slice(idx, idx + chaptersToday),
    });
    idx += chaptersToday;
  }

  return plan;
}

export const ANNUAL_PLAN: ReadingPlanDay[] = generateAnnualPlan();
